<template>
  <div>
    <!-- For Guide Tour Use -->
    <div id="map_tour_section" visibility="hidden"></div>
    <div id="csv_auto_match_step3_section" visibility="hidden"></div>
  </div>
</template>
<script src="<%= BASE_URL %>lib/jquery-3.5.1.min.js"></script>
<script>
export default {
  data() {
    return {};
  },
};
</script>